import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RequestVerificationInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const csrfToken = this.getCsrfToken();

    if (csrfToken) {
      // Clone the request and add the CSRF token to headers
      const modifiedReq = req.clone({
        setHeaders: {
          'RequestVerificationToken': csrfToken
        }
      });
      return next.handle(modifiedReq);
    }

    // If no token, proceed with the original request
    return next.handle(req);
  }

  // Retrieves the CSRF token from the page's hidden input field
  private getCsrfToken(): string | null {
    const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;
    return tokenElement ? tokenElement.value : null;
  }
}
